import angular from 'angular';
import EditUserInTeamComponent from './edit-user-in-team.component';


const editUserInTeam = angular.module('ttb.core.popups.userPopup.editUserInTeam', [])
  .component('editUserInTeam', EditUserInTeamComponent)
  .name;

export default editUserInTeam;



// WEBPACK FOOTER //
// ./components/popups/user-popup/edit-user-in-team/index.js